import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import dashboard_no_data_svg from '@/assets/images/dashboard/no_data.svg';
import dashboard_no_result_found_svg from '@/assets/images/dashboard/no_results_found.svg';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediCard } from 'incredi-ui';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-no-data',
  props: {
    icon: null,
    title: { default: '' },
    subtitle: { default: '' },
    subtitleAdditional: { default: '' },
    card: { type: Boolean, default: true },
    largeScale: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { icon: 'no_data' | 'no_result_found', title: string, subtitle: string, subtitleAdditional: string, card: boolean, largeScale: boolean }



const selectedIcon = computed(() => (props.icon === 'no_data' ? dashboard_no_data_svg : dashboard_no_result_found_svg));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { style: {"height":"100%","width":"100%","max-width":"1624px","margin":"auto"} }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(__props.card ? _unref(IncrediCard) : 'div'), {
        class: _normalizeClass(["flex flex-col justify-center items-center h-full w-full", {
        '!shadow-none border border-Border/border_natural': __props.card,
      }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: _normalizeClass(__props.largeScale ? 'w-[114px]' : 'w-[86px]'),
            src: _unref(selectedIcon)
          }, null, 10, _hoisted_1),
          (__props.title)
            ? (_openBlock(), _createElementBlock("h2", {
                key: 0,
                class: _normalizeClass([__props.largeScale ? 'leading-[26px] text-[20px] mt-[24px]' : 'leading-normal text-[13px] mt-[16px]', "font-gordita-medium text-Text/text_high"])
              }, _toDisplayString(__props.title), 3))
            : _createCommentVNode("", true),
          (__props.subtitle)
            ? (_openBlock(), _createElementBlock("h4", {
                key: 1,
                class: _normalizeClass([__props.largeScale ? 'text-[14px] mt-[16px]' : 'text-[12px] mt-[12px]', "font-gordita-regular text-Text/text_medium leading-[19px]"])
              }, _toDisplayString(__props.subtitle), 3))
            : _createCommentVNode("", true),
          (__props.subtitleAdditional)
            ? (_openBlock(), _createElementBlock("h4", {
                key: 2,
                class: _normalizeClass([__props.largeScale ? 'text-[14px]' : 'text-[12px]', "font-gordita-regular text-Text/text_medium leading-[19px]"])
              }, _toDisplayString(__props.subtitleAdditional), 3))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]))
    ]),
    _: 3
  }))
}
}

})